//FIXME: Указать типы
export const getContentLang = (locales, lang: string) => {
	return locales[lang] ? lang : locales['en'] ? 'en' : Object.keys(locales)[0]
}
